import React from 'react'

export default () => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="12.000000pt" height="12.000000pt" viewBox="0 0 72.000000 72.000000"
    preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,72.000000) scale(0.100000,-0.100000)"
      fill="#cccccc" stroke="none">
      <path d="M292 697 c-12 -13 -22 -26 -22 -30 0 -3 -11 -18 -25 -33 -32 -35 -41
-85 -23 -132 28 -73 107 -82 138 -15 17 37 30 42 30 13 0 -32 44 -70 80 -70
45 0 70 16 86 57 19 45 11 82 -29 132 -18 22 -40 51 -50 65 -24 35 -55 34 -62
-1 -4 -16 -12 -47 -18 -70 l-11 -43 -13 43 c-7 23 -13 57 -13 75 0 27 -4 32
-23 32 -13 0 -33 -10 -45 -23z"/>
      <path d="M134 508 c-19 -29 -54 -124 -54 -146 0 -62 50 -122 101 -122 30 0 99
68 99 97 0 18 -58 113 -70 113 -4 0 -11 15 -16 33 -10 34 -45 49 -60 25z"/>
      <path d="M575 450 c-9 -16 -22 -30 -29 -30 -26 0 -86 -81 -86 -114 0 -47 58
-106 104 -106 63 0 86 42 85 158 -1 112 -39 160 -74 92z"/>
      <path d="M298 303 c-9 -10 -23 -34 -32 -53 -9 -19 -35 -47 -57 -63 -49 -34
-64 -68 -49 -113 21 -63 43 -72 191 -72 119 0 133 2 155 22 14 12 27 37 30 57
6 33 2 42 -34 81 -23 24 -50 65 -61 90 -11 26 -29 51 -40 57 -31 17 -86 13
-103 -6z m90 -36 c6 -6 14 -25 17 -40 4 -15 28 -50 53 -78 44 -49 45 -52 31
-78 -14 -25 -18 -26 -104 -26 -50 -1 -100 -4 -113 -9 -17 -6 -29 -1 -52 23
-17 16 -30 36 -30 43 0 8 24 35 54 61 30 26 58 57 62 69 3 13 11 29 16 36 13
16 53 16 66 -1z"/>
    </g>
  </svg>
)
